import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './Whatsapp.css';
import { toast } from 'react-toastify';
import AttachmentPreview from './attachment/AttachmentPreview';

const WhatsApps = ({
    onSendMessage,
    chatData,
    profileId,
    getChatById,
    selectedMail,
    chatContainerRef,
    isSocketConnected,
    sendingMessages = new Set(),
    taskData,
    onContactSelect,
    selectedContact,
    selectedImages,
    setSelectedImages,
    selectedGroupContacts,
    loading,
    handleScroll
}) => {
    const [message, setMessage] = useState('');
    // Image preview state
    const [previewImage, setPreviewImage] = useState(null);

    const handleInputChange = (e) => {
        setMessage(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (message.trim() !== '' || selectedImages) {
            onSendMessage(message);
            setMessage('');
            setSelectedImages([]);
        }
    };
    const convertEpochToTime = (epoch) => {
        const date = new Date(epoch * 1000);
        return date.toLocaleTimeString('en-US', { hour12: false });
    };

    const handleRefresh = () => {
        if (selectedContact) {
            getChatById(selectedContact.contactId);
        }
    };

    const handleSelectContact = (contact) => {
        if (onContactSelect) {
            onContactSelect(contact);
        }
    };

    const colors = [
        '#1e88e5',
        '#e53935',
        '#8e24aa',
        '#43a047',
        '#fb8c00',
        '#00acc1',
        '#6d4c41',
        '#f4511e',
        '#3949ab',
        '#00897b',
    ];

    function getColorFromName(name = '') {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % colors.length;
        return colors[index];
    }

    const handleRemoveImage = (idx) => {
        setSelectedImages((prev) => prev.filter((_, i) => i !== idx));
    };

    const MAX_IMAGES = 4;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (selectedImages.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setSelectedImages((prev) => [...prev, ...newFiles]);
        }
    };

    const headerName = selectedGroupContacts?.label || selectedContact?.name || selectedContact?.contactNo || 'Select a chat';




    return (
        <div className="flex h-screen  font-sans">
            {/* Image Preview Modal */}
            {previewImage && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                    }}
                    onClick={() => setPreviewImage(null)}
                >
                    <div
                        style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                borderRadius: 12,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.3)',
                            }}
                        />
                        <button
                            onClick={() => setPreviewImage(null)}
                            style={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                background: 'rgba(0,0,0,0.6)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '50%',
                                width: 32,
                                height: 32,
                                fontSize: 20,
                                cursor: 'pointer',
                            }}
                            aria-label="Close preview"
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
            {/* Sidebar */}
            {/* <aside className="w-[340px] bg-white flex flex-col border-r border-[#e9edef]">
                <div className="h-[60px] flex items-center px-5 bg-white text-[#54656f] text-xl font-bold border-b border-[#e9edef]">
                    Chats
                </div>
                <div className="p-3 bg-[#f0f2f5] border-b border-[#e9edef]">
                    <input
                        type="text"
                        placeholder="Search or start new chat"
                        className="w-full px-4 py-2 rounded-lg bg-white text-[#54656f] text-base outline-none border border-[#e9edef] placeholder-[#8696a0] focus:border-[#00a884]"
                    />
                </div>
                <div className="flex-1 overflow-y-auto bg-white">
                    {Array.isArray(taskData) && taskData.length > 0 ? (
                        taskData.map((item, idx) => {
                            const contact = item.Contact;

                            if (!contact) return null;
                            const isSelected = selectedContact && selectedContact.contactId === contact.contactId;
                            return (
                                <div
                                    key={contact.contactId || idx}
                                    className={`flex items-center px-5 py-3 cursor-pointer transition-colors duration-200 hover:bg-[#f0f2f5] border-b border-[#f0f2f5] ${isSelected ? 'bg-[#e8f5e8] border-l-4 border-l-[#00a884]' : ''
                                        }`}
                                    onClick={() => handleSelectContact(contact)}
                                >
                                    <div className="w-12 h-12 rounded-full bg-[#00a884] text-white flex items-center justify-center text-xl font-bold mr-4">
                                        {
                                            contact?.profileImage && contact?.profileImage.trim() !== "" ?
                                                <img src={`${process.env.REACT_APP_IMAGE_URL}/${contact?.profileImage}`} alt="profile" className="w-full h-full rounded-full" />
                                                :
                                                <i className="fas fa-user text-xl"></i>
                                        }
                                    </div>
                                    <div className="flex flex-col flex-1">
                                        <div className="text-[#111b21] font-medium text-base">
                                            {contact?.name || 'Unknown'}
                                        </div>
                                        <div className="text-[#8696a0] text-sm">{contact?.contactNo}</div>
                                    </div>
                                    {isSelected && <div className="w-2 h-2 rounded-full bg-[#00a884]"></div>}
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-[#8696a0] p-5 text-center">No contacts found.</div>
                    )}
                </div>
            </aside> */}
            {/* Chat Area */}
            <div className="flex-1 flex flex-col px-[2vw]">
                <section className="msger flex flex-col h-full">

                    <header className="msger-header sticky top-0 z-10 ">

                        <div className="msger-header-title flex flex-col justify-center items-center gap-2">
                            <div className="flex items-center gap-2">
                                <div
                                    className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 text-gray-600"
                                >
                                    {
                                        selectedContact?.profileImage && selectedContact?.profileImage.trim() !== ""
                                            ? (
                                                <img
                                                    src={`${process.env.REACT_APP_IMAGE_URL}/${selectedContact?.profileImage}`}
                                                    alt="profile"
                                                    className="w-full h-full rounded-full object-cover"
                                                    onError={e => { e.target.onerror = null; e.target.src = "/default-profile.png"; }}
                                                />
                                            )
                                            : (
                                                <i className="fas fa-user text-xl"></i>
                                            )
                                    }
                                </div>
                                {headerName}
                            </div>
                        </div>
                        <div className="msger-header-options flex items-center gap-2">
                            <div
                                className="flex items-center gap-1 text-xs"
                                style={{ color: isSocketConnected ? '#4CAF50' : '#f44336' }}
                                title={isSocketConnected ? 'Socket Connected' : 'Socket Disconnected'}
                            >
                                <span
                                    className="inline-block rounded-full"
                                    style={{
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: isSocketConnected ? '#4CAF50' : '#f44336',
                                    }}
                                ></span>
                                {isSocketConnected ? 'Connected' : 'Disconnected'}
                            </div>
                            {/* <div onClick={handleRefresh} className="cursor-pointer" title="Refresh">
                                <i className="fas fa-sync-alt" />
                            </div> */}
                        </div>
                    </header>
                    <main className="msger-chat flex-1 overflow-y-auto mb-[52px]" ref={chatContainerRef}  >
                        {!selectedContact && !selectedGroupContacts?.value ? (
                            <div className="flex items-center justify-center h-full text-[#8696a0] text-lg">

                            </div>
                        ) : loading ? (
                            <div className="flex items-center justify-center h-full text-[#8696a0] text-lg">
                                <div className="flex items-center gap-2">
                                    <span className="loader w-5 h-5 border-2 border-t-transparent rounded-full animate-spin border-[#8696a0]"></span>
                                    <span>Loading chat...</span>
                                </div>
                            </div>
                        ) : chatData && chatData?.length > 0 ? (
                            chatData?.filter((item) => item?.
                                attachementPath?.length > 0 || item?.message).map((data, index) => (
                                    <div
                                        key={data?.id || index}
                                        // className={data?.messageSendBy === profileId ? 'msg left-msg' : 'msg right-msg'}
                                        className={
                                            data?.messageSendBy?.split('@')[0] === profileId?.split('@')[0]
                                                ? 'msg left-msg'
                                                : 'msg right-msg'
                                        }
                                    >
                                        <div
                                            className="msg-img"
                                            style={{
                                                backgroundImage: `url(${data?.messageSendBy === profileId
                                                    ? 'https://image.flaticon.com/icons/svg/145/145867.svg'
                                                    : 'https://image.flaticon.com/icons/svg/327/327779.svg'
                                                    })`,
                                            }}
                                        />

                                        <div>
                                            {/* {data?.lastSeen != null && data.lastSeen !== "" ? */}
                                            <div className="msg-bubble">
                                                <div className="msg-info">
                                                    {data?.chatType === 'group' && (
                                                        <div className="msg-info-name">Sajad</div>
                                                    )}
                                                    <div
                                                        className="msg-info-time"
                                                        style={{ color: getColorFromName(data?.participantName || '') }}
                                                    >
                                                        <span>{data?.participantName}</span>
                                                    </div>
                                                </div>


                                                <div className="msg-text d-flex flex-col">
                                                    <div>
                                                        <AttachmentPreview data={data} />
                                                    </div>

                                                    <div className="d-flex items-center gap-2 justify-between">
                                                        <span className="fs-12 break-words max-w-[85%]" style={{ marginBottom: '0' }}>
                                                            {typeof data?.message === 'string'
                                                                ? data.message
                                                                : typeof data?.message?.body === 'string'
                                                                    ? data.message.body
                                                                    : JSON.stringify(data?.message)}
                                                        </span>

                                                        <span>
                                                            {data?.lastSeen != null && data.lastSeen !== ""
                                                                ? convertEpochToTime(data.lastSeen)
                                                                : ""}
                                                        </span>


                                                        {sendingMessages.has(data?.id) && (
                                                            <span className="text-muted text-xs">
                                                                <i className="fas fa-clock"></i> Sending...
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* : ""} */}


                                        </div>
                                    </div>
                                ))
                        ) : (
                            <div className="flex items-center justify-center h-full text-[#8696a0] text-lg">
                                No messages yet. Start the conversation!
                            </div>
                        )}
                    </main>


                    <div className="sticky bottom-0 z-10 bg-[#e5ddd5] px-[1vw] py-[1vw]">
                        <form className="msger-inputarea rounded-full px-[1.5vw] gap-[1vw] flex items-center" onSubmit={handleSubmit}>
                            {/* Attachment Icon */}
                            <input
                                type="file"
                                id="attachment-input"
                                className="hidden"
                                onChange={handleFileChange}
                                multiple
                                accept="image/*"
                            />

                            {/* Label with paperclip icon */}
                            <label htmlFor="attachment-input" className="cursor-pointer mr-2" title="Attach file">
                                <i className="fas fa-paperclip text-lg"></i>
                            </label>

                            <input
                                type="text"
                                className="msger-input flex-1 px-[1vw] rounded bg-white text-white placeholder-[#8696a0] border-none outline-none"
                                placeholder={
                                    selectedContact || selectedGroupContacts?.value ? 'Enter your message...' : ''
                                }
                                value={message}
                                onChange={handleInputChange}
                            // disabled={!selectedContact}
                            />
                            <div className='flex items-center gap-[1vw]'>
                                {selectedImages?.map((file, idx) => (
                                    <div
                                        key={idx}
                                        className="preview-container"
                                        style={{
                                            position: 'relative',
                                            width: 100,
                                            height: 100,
                                            display: 'inline-block',
                                            marginBottom: 12,
                                            background: '#fff',
                                            boxSizing: 'border-box',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {file.type.startsWith('image/') ? (
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={`Preview ${idx}`}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: 8,
                                                    boxShadow:
                                                        'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                                                }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexDirection: 'column',
                                                    fontSize: 32,
                                                    color: '#2196f3',
                                                    background: '#fafafa',
                                                    borderRadius: 8,
                                                }}
                                            >
                                                {file.name.endsWith('.xls') || file.name.endsWith('.xlsx') ? (
                                                    <span role="img" aria-label="xls">
                                                        📄<div style={{ fontSize: 12, color: '#888' }}>XLS</div>
                                                    </span>
                                                ) : file.name.endsWith('.pdf') ? (
                                                    <span role="img" aria-label="pdf">
                                                        📄<div style={{ fontSize: 12, color: '#888' }}>PDF</div>
                                                    </span>
                                                ) : (
                                                    <span role="img" aria-label="file">
                                                        📄<div style={{ fontSize: 12, color: '#888' }}>FILE</div>
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className="remove-image-btn"
                                            onClick={() => handleRemoveImage(idx)}
                                            title="Remove"
                                        >
                                            &times;
                                        </button>
                                    </div>

                                ))}
                            </div>

                            <button
                                type="submit"
                                className={`w-[3vw] h-[3vw] p-[0.6vw] rounded-full flex items-center justify-center shadow-md transition-colors duration-200 ${selectedContact || selectedGroupContacts?.value
                                    ? 'bg-[#00A884] hover:bg-[#029174] text-white'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    }`}
                            // disabled={!selectedContact}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" />
                                </svg>
                            </button>
                        </form>
                    </div>

                </section>
            </div>
        </div>
    );
};

WhatsApps.propTypes = {
    onSendMessage: PropTypes.func.isRequired,
    chatData: PropTypes.array.isRequired,
    profileId: PropTypes.string,
    getChatById: PropTypes.func.isRequired,
    selectedMail: PropTypes.string,
    chatContainerRef: PropTypes.object,
    isSocketConnected: PropTypes.bool,
    sendingMessages: PropTypes.instanceOf(Set),
    onContactSelect: PropTypes.func,
    selectedContact: PropTypes.object,
};

export default WhatsApps;
